<template >
    <div>
      <a :href='tel' ref="link">点击拨打车主电话</a>
    </div>
</template>

<script>
export default {
  name: 'parkcode',
  data () {
    return {
      tel: 'tel:'
    }
  },
  methods: {
    getParam () {
      this.tel = this.tel + this.$route.query.tel
    }
  },
  mounted () {
    this.$refs.link.click()
  },
  created () {
    this.getParam()
  }
}
</script>



// WEBPACK FOOTER //
// src/view/parkcode.vue